module.exports = __webpack_public_path__ + "static/img/mood8.436ddff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood8.png
// module id = eSpz
// module chunks = 1